import { MinMax, TableV3FilterItem } from 'common/table/types/TableV3';

type MinOrMax = keyof MinMax;

const MIN_AND_MAX: MinOrMax[] = ['min', 'max'];

export const minMaxToTableFilterItems = (minMax: MinMax): TableV3FilterItem[] =>
  MIN_AND_MAX.flatMap((minOrMax) => {
    const value = minMax[minOrMax];
    return value === undefined
      ? []
      : [{ value: `${minOrMax}:${value}`, label: value }];
  });

export const tableFilterItemsToMinMax = (items: TableV3FilterItem[]): MinMax =>
  items.reduce<MinMax>((minMax, item) => {
    const minOrMax = MIN_AND_MAX.find((name) =>
      item.value.startsWith(`${name}:`)
    );
    if (!minOrMax) return minMax;

    const value = item.value.slice(minOrMax.length + 1);
    return value ? { ...minMax, [minOrMax]: value } : minMax;
  }, {});
